import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "choice-toggle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_w_tool_tip, {
    text: _ctx.firstOptionTooltip,
    placement: _ctx.tooltipPosition
  }, {
    default: _withCtx(() => [_createElementVNode("button", {
      class: _normalizeClass(["toggle-button left", {
        active: _ctx.isFirstOptionChoosed
      }]),
      onClick: _cache[0] || (_cache[0] = $event => _ctx.setFirstOptionState(true))
    }, [_ctx.firstOptionIcon ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: _ctx.firstOptionIcon,
      class: "icon"
    }, null, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.firstOption), 1)], 2)]),
    _: 1
  }, 8, ["text", "placement"]), _createVNode(_component_w_tool_tip, {
    text: _ctx.secondOptionTooltip,
    placement: _ctx.tooltipPosition
  }, {
    default: _withCtx(() => [_createElementVNode("button", {
      class: _normalizeClass(["toggle-button right", {
        active: !_ctx.isFirstOptionChoosed
      }]),
      onClick: _cache[1] || (_cache[1] = $event => _ctx.setFirstOptionState(false))
    }, [_ctx.secondOptionIcon ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: _ctx.secondOptionIcon,
      class: "icon"
    }, null, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.secondOption), 1)], 2)]),
    _: 1
  }, 8, ["text", "placement"])]);
}